module.exports = __webpack_public_path__ + "img/file-upload.5acedc24.svg";